import api from './api';

export interface AnuidadeSocio {
  id: number;
  nome: string;
  codigo: string;
}

export interface Anuidade {
  id?: number;
  socio?: AnuidadeSocio;
  socio_id?: number;
  ano: number;
  data_vencimento: string;
  valor: number;
  status?: string;
  data_pagamento?: string | null;
  observacoes?: string;
}

export interface AnuidadeCreate {
  socio_id: number;
  ano: number;
  data_vencimento: string;
  valor: number;
  observacoes?: string;
}

export const anuidadeService = {
  async listar(params?: {
    skip?: number;
    limit?: number;
    socio_id?: number;
    ano?: number;
    status?: string;
  }): Promise<Anuidade[]> {
    const response = await api.get<Anuidade[]>('/api/anuidades/', { params });
    return response.data;
  },

  async criar(anuidade: AnuidadeCreate): Promise<Anuidade> {
    const response = await api.post<Anuidade>('/api/anuidades/', anuidade);
    return response.data;
  },

  async pagar(anuidadeId: number, data_pagamento: string): Promise<Anuidade> {
    const response = await api.patch<Anuidade>(`/api/anuidades/${anuidadeId}/pagar`, {
      data_pagamento,
    });
    return response.data;
  },
};
